// extracted by mini-css-extract-plugin
module.exports = {"select":"MultiSelect_select__2CRIh","item":"MultiSelect_item__2wEhS","label":"MultiSelect_label__3jh3e"};